"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dataFetchActions_1 = require("../../dataFetchActions");

exports.crudUpdateMany = function (resource, ids, data, basePath, refresh) {
  if (refresh === void 0) {
    refresh = true;
  }

  return {
    type: exports.CRUD_UPDATE_MANY,
    payload: {
      ids: ids,
      data: data
    },
    meta: {
      resource: resource,
      fetch: dataFetchActions_1.UPDATE_MANY,
      onSuccess: {
        notification: {
          body: 'ra.notification.updated',
          level: 'info',
          messageArgs: {
            smart_count: ids.length
          }
        },
        basePath: basePath,
        refresh: refresh,
        unselectAll: true
      },
      onFailure: {
        notification: {
          body: 'ra.notification.http_error',
          level: 'warning'
        }
      }
    }
  };
};

exports.CRUD_UPDATE_MANY = 'RA/CRUD_UPDATE_MANY';
exports.CRUD_UPDATE_MANY_LOADING = 'RA/CRUD_UPDATE_MANY_LOADING';
exports.CRUD_UPDATE_MANY_FAILURE = 'RA/CRUD_UPDATE_MANY_FAILURE';
exports.CRUD_UPDATE_MANY_SUCCESS = 'RA/CRUD_UPDATE_MANY_SUCCESS';